import { render, staticRenderFns } from "./layer-bzf-publish.vue?vue&type=template&id=c3889e7e&scoped=true&"
import script from "./layer-bzf-publish.vue?vue&type=script&lang=js&"
export * from "./layer-bzf-publish.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3889e7e",
  null
  
)

export default component.exports